import type CredOrg from '$shared/models/CredOrg';
import BaseStore from './BaseStore';

export type AuthStoreType = {
  credOrgs: CredOrg[];
};

const InitialState: AuthStoreType = {
  credOrgs: []
};

class AuthStore extends BaseStore<AuthStoreType> {
  constructor() {
    super(InitialState);
  }

  public get credOrgs(): CredOrg[] {
    return this.getValue('credOrgs') || [];
  }

  public setCredOrgs(orgs: CredOrg[]): void {
    this.update('credOrgs', orgs);
  }
}

export const authStore = new AuthStore();
